<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-slot-gameRarity-outline"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingGameRarity"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="gameRarity.name"
                        >
                          <v-text-field
                            v-model="gameRarity.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.gameRarity.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      v-model="gameRarity.gamesSelected"
                      :items="gameList"
                      item-text="name"
                      item-value="id"
                      label="Juegos que la utilizan"
                      multiple
                      outlined
                    />
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const gameRaritiesRespository = repositoryFactory.get('gameRarities')
  const gameLinesRespository = repositoryFactory.get('gameLines')

  export default {
    inject: ['theme'], // ??
    name: 'GameRarityCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      gameRarity: {
        isRented: false,
        gamesSelected: [],
      },
      gameRarityStatuses: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingGameRarity: false,
      formAction: null,
      loadingSave: false,
      gameList: [],
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-gameRarity') : this.$t('modify-gameRarity')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingGameRarity = true
        var id = this.$route.params.id
        gameRaritiesRespository.getById(id).then(response => {
          self.loadingGameRarity = false
          self.gameRarity = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingGameRarity = false
          alert(err)
        })
      }
      this.getGames()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.gameRarity,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          gameRaritiesRespository.updateGameRarity(data, this.gameRarity.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          gameRaritiesRespository.addGameRarity(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'gameRarities' })
      },
      getGames () {
        var self = this
        gameLinesRespository.get().then(response => {
          self.gameList = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
    },
  }
</script>
